import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios"; // ✅ import axios
import "./Login.css";

const BackendURL = process.env.REACT_APP_BACKEND_URL;
const API_BASE =
  `${BackendURL}/auth`;

const Login = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtpSection, setShowOtpSection] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSignup, setIsSignup] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  
  // Step 1: request OTP
  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    try {
      setIsLoading(true);
      setError("");

      const endpoint = isSignup
        ? `${API_BASE}/signup/request-otp`
        : `${API_BASE}/login/request-otp`;

      const body = isSignup ? { name, email } : { email };

      // ✅ axios POST
      const { data } = await axios.post(endpoint, body, {
        headers: { "Content-Type": "application/json" },
      });

      console.log("otp response:", data);
      setShowOtpSection(true);
    } catch (err) {
      console.error("error:", err.response?.data || err.message);
      setError(err.response?.data?.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  // Step 2: verify OTP
  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    if (otp.length !== 6) return;

    try {
      setIsLoading(true);
      setError("");

      const endpoint = isSignup
        ? `${API_BASE}/signup/verify-otp`
        : `${API_BASE}/login/verify-otp`;

      // ✅ axios POST
      const { data } = await axios.post(
        endpoint,
        { email, otp, name },
        {
          headers: { "Content-Type": "application/json" },
        },
      );

      console.log("verify response:", data);

      // ✅ Save JWT in localStorage
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));

      navigate("/");
    } catch (err) {
      console.error("error:", err.response?.data || err.message);
      setError(err.response?.data?.message || "Invalid OTP");
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackToEmail = () => {
    setShowOtpSection(false);
    setOtp("");
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="brand-logo">
          <h1>AYBL</h1>
        </div>

        {!showOtpSection ? (
          <div className="login-section">
            <div className="login-header">
              <h2>{isSignup ? "Register" : "Sign in"}</h2>
              <p>
                {isSignup
                  ? "Create a new account"
                  : "Enter your email to continue"}
              </p>
            </div>

            {error && <p className="error-msg">{error}</p>}

            <form onSubmit={handleEmailSubmit} className="email-form">
              {isSignup && (
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
              )}
              <div className="input-group">
                <input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <button
                type="submit"
                className="continue-btn"
                disabled={!email || (isSignup && !name) || isLoading}
              >
                {isLoading ? "Sending..." : "Continue"}
              </button>
            </form>

            <p className="switch-auth">
              {isSignup ? (
                <>
                  Already have an account?{" "}
                  <span
                    className="auth-link"
                    onClick={() => {
                      setIsSignup(false);
                      setEmail("");
                      setName("");
                    }}
                  >
                    Login
                  </span>
                </>
              ) : (
                <>
                  Don’t have an account?{" "}
                  <span
                    className="auth-link"
                    onClick={() => {
                      setIsSignup(true);
                      setEmail("");
                      setName("");
                    }}
                  >
                    Register
                  </span>
                </>
              )}
            </p>
          </div>
        ) : (
          <div className="otp-section">
            <div className="otp-header">
              <h2>Enter verification code</h2>
              <p>We've sent a verification code to {email}</p>
            </div>

            {error && <p className="error-msg">{error}</p>}

            <form onSubmit={handleOtpSubmit} className="otp-form">
              <div className="input-group">
                <input
                  type="text"
                  placeholder="Enter 6-digit code"
                  value={otp}
                  onChange={(e) =>
                    setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
                  }
                  maxLength={6}
                  required
                />
              </div>
              <button
                type="submit"
                className="verify-btn"
                disabled={otp.length !== 6 || isLoading}
              >
                {isLoading ? "Verifying..." : "Verify"}
              </button>
            </form>

            <button
              className="back-btn"
              onClick={handleBackToEmail}
              disabled={isLoading}
            >
              ← Back
            </button>
          </div>
        )}

        <div className="footer-links">
          <Link to="/privacy">Privacy policy</Link>
          <Link to="/terms">Terms of service</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
